import { FunnelModal } from '../../funnel/modal/funnel-modal';
import { PartyModal } from '../../party/modal/party-modal';
import { QuotationDetailModel } from './quotation-detail-model';
import { UserModal } from '../../user/modal/user-modal';
import { PartyDetailModal } from '../../party/modal/party-detail-modal';
import { StatusModel } from '../../pre-inward/modal/status-model';

export class QuotationModel {
  id: number;
  quotationNo: string;
  project: FunnelModal;
  customer: PartyModal;
  customerRepresentative: PartyDetailModal;
  projectId:number;
  customerId:number;
  partnerId:number;
  createdDate: Date = new Date();
  totalAmount: number;
  termsOfDelivery: string;
  logistic: string;
  termsOfFor: string;
  termsOfTax = 'Tax: As applicable 18% GST extra';
  termsOfPayment = '30 Days';
  validity: string = '30';
  termsOfOther: string;
  createdBy: UserModal;
  createdById:number;
  status:boolean;
  contactDetail: Array<PartyDetailModal>;
  segment: string;
  shippingAddress: string;
  approvalStatus: StatusModel;
  details: Array<QuotationDetailModel>;
  quotationItemDetails: Array<QuotationDetailModel>;
  // Angular Use
  date: string;
  projectName: string;
  customerName: string;
  crName:string;
  staff: string;
  totalAmt: any;
  totalDiscount: any;
  totalGSTAmount:any;
  totalFinalAmt: any;
  generateOrder: string;
  statusName: string;
  moduleName: string;
  poReference : string;
  poDate : Date;
  customerExpectedDate : Date;
  estimatedShippingDate : Date;
  remark:string;
}
